import script from "./VT.vue?vue&type=script&lang=js"
export * from "./VT.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__